import * as React from 'react';
import { Switch as MatSwitch, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, SxProps, Theme } from '@mui/material';

type SwitchColor = 'primary' | 'secondary' | 'default';
type MarginType = 'dense' | 'normal' | 'none';

// TODO: Must add unique identifier per switch group/
interface SwitchGroup {
  label?: string;
  helperText?: string;
  items: SwitchItem[];
}

interface SwitchItem {
  color?: SwitchColor;
  description: string;
  id: string;
  isChecked: boolean;
  isEnabled: boolean;
}

export interface SwitchProps {
  switchGroup: SwitchGroup;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (id: string) => void;
  required?: boolean;
  margin?: MarginType;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

const Switch: React.FunctionComponent<SwitchProps> = ({ switchGroup: { label, helperText, items }, onChange, fullWidth, ...rest }: SwitchProps) => (
  <React.Fragment>
    <FormControl fullWidth={fullWidth} {...rest}>
      <FormGroup>
        {label && <FormLabel>{label}</FormLabel>}
        {items.map(({ isChecked, id, isEnabled, color, description }: SwitchItem) => (
          <FormControlLabel
            control={
              <MatSwitch
                checked={isChecked}
                value={id}
                disabled={!isEnabled}
                onChange={onChange && (event => onChange(event.currentTarget.value))}
                color={color as SwitchColor}
              />
            }
            label={description}
            key={id}
          />
        ))}
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  </React.Fragment>
);

Switch.defaultProps = {
  fullWidth: true
};

Switch.displayName = 'Switch';

export { Switch };
